import { render, staticRenderFns } from "./PrintContractForSJ.vue?vue&type=template&id=0065b8fc&scoped=true&"
import script from "./PrintContractForSJ.vue?vue&type=script&lang=js&"
export * from "./PrintContractForSJ.vue?vue&type=script&lang=js&"
import style0 from "./PrintContractForSJ.vue?vue&type=style&index=0&id=0065b8fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0065b8fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VContainer,VRow,VSnackbar})
